export default "__VITE_ASSET__CqoiuAfS__"